import React from 'react';
import { Badge, FormCheck } from 'react-bootstrap';

export default function FilterButton(props) {
    return (
        <>
        <Badge bg="light">
            {props.name}
        </Badge>
            <FormCheck
                // style={{ textIndent: "20px" }} 
                disabled={props.disabled}
                id={props.id} 
                defaultChecked={props.defaultChecked}
                onChange={props.onChange}
            />
        </>
    )
}